import { createUseContext } from '@boxcryptor-web/shared/react-hooks';
import * as React from 'react';
import { ExternalLink, ExternalLinkProps } from './ExternalLink';

export type ExternalLinkReplacement = ExternalLink;
export type ExternalLinkReplacements = Record<string, ExternalLinkReplacement>;
export type ExternalLinkContextProps = {
  externalLinkComponent: React.FC<ExternalLinkProps>;
  getReplacedExternalLink: (link: ExternalLink) => ExternalLinkReplacement;
};

const ExternalLinkContext = React.createContext<ExternalLinkContextProps>({
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  externalLinkComponent: (props) => <a {...props} />,
  getReplacedExternalLink: (link) => link,
});

export const useExternalLinkContext = createUseContext('ExternalLinkContext', ExternalLinkContext);
export const ExternalLinkContextProvider = ExternalLinkContext.Provider;
